import styled from '@emotion/styled'

import { CarouselButton, CarouselContent } from '~/shared/molecules/Carousel'

export const StyledCarouselContent = styled(CarouselContent)`
  min-width: 400px;
`

export const StyledCarouselButton = styled(CarouselButton)`
  width: 2.5rem;
  height: 2.5rem;
  img {
    height: 0.875rem;
  }
`
